if (!customElements.get("menu-tabs")) {
  class MenuTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll(".menu-tabs__button");
      this.contents = this.querySelectorAll(".menu-tabs__content");

      this.buttons.forEach((button, index) => {
        button.addEventListener("click", () => {
          let state =
            this.buttons[index].dataset.open === "true" ? true : false;

          this.contents.forEach((con) =>
            con.setAttribute("data-open", "false")
          );
          this.buttons.forEach((btn) => btn.setAttribute("data-open", "false"));

          this.contents[index].setAttribute("data-open", !state);
          this.buttons[index].setAttribute("data-open", !state);
        });
      });
    }
    toggleContents(index) {
      this.contents.forEach((con) => con.setAttribute("data-open", "false"));
      this.contents[index].setAttribute("data-open", "true");
    }

    toggleButtons(index) {
      this.buttons.forEach((btn) => btn.setAttribute("data-open", "false"));
      this.buttons[index].setAttribute("data-open", "true");
    }
  }

  customElements.define("menu-tabs", MenuTabs);
}